import { useQuery } from '@tanstack/react-query';
import accessControlService from 'v2/services/access-control';

export const useAccessPolicyUsers = () => {
  const result = useQuery({
    queryKey: ['access-policy-users'],
    queryFn: () => accessControlService.listUsers()
  });

  return {
    users: result?.data?.data ?? [],
    isFetching: result.isLoading,
    isError: result.isError,
    refetch: result.refetch
  };
};
